import React from 'react';
import { ReactComponent as IconSvg }      from '../assets/brand/logo_icon.svg';
import { ReactComponent as PrimarySvg }   from '../assets/brand/logo_primary.svg';
import { ReactComponent as SokomarkSvg }  from '../assets/brand/logo_soko.svg';
import { ReactComponent as WordmarkSvg }  from '../assets/brand/logo_wordmark.svg';
import { ReactComponent as MonochromeSvg} from '../assets/brand/logo_monochrome.svg';

/**
 * SoKo Water Systems logo.
 *
 * Variants:
 *   "icon"       — tank mark only (default; for nav, favicons, app icons)
 *   "primary"    — tank mark + SOKO wordmark + WATER SYSTEMS descriptor
 *   "wordmark"   — SOKO + WATER SYSTEMS, no icon
 *   "sokomark"   — SOKO only, no descriptor (in-app contexts where the
 *                  brand is already established — e.g., the app TopBar)
 *   "monochrome" — single-color version for etching / restricted color
 *
 * Use `width` to control size; height scales automatically via SVG aspect ratio.
 */
export default function Logo({ variant = 'icon', width = 28, className, style, ...rest }) {
  const Svg =
    variant === 'primary'    ? PrimarySvg :
    variant === 'wordmark'   ? WordmarkSvg :
    variant === 'sokomark'   ? SokomarkSvg :
    variant === 'monochrome' ? MonochromeSvg :
                               IconSvg;

  return (
    <Svg
      width={width}
      className={className}
      style={style}
      role="img"
      aria-label="SoKo Water Systems"
      {...rest}
    />
  );
}